import Plugin from "@/scripts/core/Plugin";
import init from "@/scripts/core/init";
import { CLASSES, STATES } from "@/scripts/helpers/constants";

const addActiveClass = element => {
  !element.hasClass("is-active") && element.addClass("is-active");
};

const removeActiveClass = element => {
  element.hasClass("is-active") && element.removeClass("is-active");
};

class MobileMenu extends Plugin {
  init() {
    const handleSearchButton = () => {
      const searchButton = $(
        ".header-navbar__item--search .header-navbar__item-action"
      );
      const searchPanel = $(".header-search");
      const searchPanelOuter = $(".header-search__underlay");
      const searchField = $(".search-field");
      const mobileMenuButton = $(".header-navbar__item--trigger");
      const userInfoAction = $(".js-user-info-combobox");

      searchButton.off().on("click", function() {
        userInfoAction.removeClass("is-open");
        searchPanel.toggleClass(CLASSES.VISIBLE);
        searchButton.toggleClass(CLASSES.ACTIVE);
        searchField.trigger("focus");
      });

      searchPanelOuter.on("click", function() {
        searchPanel.removeClass(CLASSES.VISIBLE);
        searchButton.removeClass(CLASSES.ACTIVE);
        searchField.off("focus");
      });

      mobileMenuButton.on("click", function() {
        searchPanel.removeClass(CLASSES.VISIBLE);
        searchButton.removeClass(CLASSES.ACTIVE);
        searchField.off("focus");
      });
    };

    const handleSelect = () => {
      const select = $(".js-search-select-state select");
      const selectWrapper = select.parent();
      const selectMask = $("#mobile-search .js-search-select-mask");
      const searchForm = $(".search");

      select.on("click keydown", function(e) {
        const { type, keyCode } = e;
        e.stopPropagation();
        if (type === "click") {
          addActiveClass(selectWrapper);
          addActiveClass(searchForm);
        }
        if (type === "keydown") {
          if (keyCode === 32) {
            addActiveClass(selectWrapper);
            addActiveClass(searchForm);
          }
        }
      });

      select.on("change blur", function() {
        selectWrapper.removeClass("search__select-state--placeholder");
        removeActiveClass(selectWrapper);
        // removeActiveClass(searchForm);

        const maskBody = selectMask.find(".search__select-state-body");
        const selectOptionText = STATES[select.val()];

        if (maskBody.text() !== selectOptionText)
          maskBody.text(selectOptionText);
      });
    };

    const toggleMobileMenuItem = (selector, isAnimated = true) => {
      selector.off().on("click", function() {
        $(this).toggleClass(CLASSES.ACTIVE);
        if (isAnimated) {
          $(this)
            .next()
            .slideToggle();
        }
      });
    };

    const handleMenuItem = () => {
      const mobileMenuTitle = $(".mobile-menu__title");

      toggleMobileMenuItem(mobileMenuTitle);
    };

    const handleCategoryItem = () => {
      const categoriesTitle = $(".categories-list__title");
      const backwardButton = $(".backward-button");

      toggleMobileMenuItem(categoriesTitle, false);

      backwardButton.off().on("click", function() {
        categoriesTitle.each(function() {
          $(this).hasClass("is-active") && $(this).removeClass("is-active");
        });
      });
    };

    handleSelect();
    handleSearchButton();
    handleMenuItem();
    handleCategoryItem();
  }
}

export default init(MobileMenu, "mobile-menu");
